import React, { useEffect, useState } from 'react'
import classes from './scanFinished.module.scss'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { resultsFormating } from '../../store/reducers/ResultsReducer/ResultsReducer'
import {ClearInputs} from '../../store/reducers/ScanReducer/RegistrationScanReducer'
import { laborantService } from '../../api/laborantService'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const ScanFinished = ({numbers}) => {

    const dispatch = useDispatch()
    // const [ptint, setPrint] = useState(false)
    const regForm = useSelector(state=>state.RegScan.ScanInputs)
    const [values, setValues] = useState()

    const [scaned, setScaned] = useState({
      "data": {
        "cassets": []
      },
      "status": ''
    })
    

    const {
        register,
        handleSubmit,
    } =useForm()

    const onSubmit = (data) =>{
        let scanedData = []
        if (regForm.research == 'Гістологія'){
          if (status == 'scanAfterForm'){
            let cassets = []
            for(let key in data){
              if (data[key] !== ''){
                cassets.push(data[key])
                scanedData ={
                  "data": {
                    "cassets": cassets
                  },
                  "status": "scanBeforePaint"
                }
              }
            }
          } else if (status == 'scanBeforePaint'){
            let cassets = []
            for(let key in data){
              if (data[key] !== ''){
                cassets.push(data[key])
                scanedData = {
                  "data": {
                    "cassets": cassets
                  },
                  "status": "scanAfterPaint"
                }
              }
            }
          } else if (status == 'scanAfterPaint'){
            let cassets = []
            for(let key in data){
              if (data[key] !== ''){
                cassets.push(data[key])
                scanedData = {
                  "data": {
                    "cassets": cassets
                  },
                  "status": "toDoctor"
                }
              }
            }
          }
        } else if (regForm.research == 'Експрес'){
          if (status == 'scanAfterForm'){
            let cassets = []
            for(let key in data){
              if (data[key] !== ''){
                cassets.push(data[key])
                scanedData ={
                  "data": {
                    "cassets": cassets
                  },
                  "status": "scanAfterPaint"
                }
              }
            }
          } else if (status == 'scanAfterPaint'){
            let cassets = []
            for(let key in data){
              if (data[key] !== ''){
                cassets.push(data[key])
                scanedData = {
                  "data": {
                    "cassets": cassets
                  },
                  "status": "toDoctor"
                }
              }
            }
          }

        } else {
          let cassets = []
          for(let key in data){
            cassets.push(data[key])
            scanedData ={
              "data": {
                "cassets": cassets
              },
              "status": "toDoctor"
            }
          }
        }
        setScaned(scanedData)
    }

    const inputs = []

    useEffect(()=>{
      if (numbers >= 0 && numbers !== ''){
        let inputs = []
        for (let i = 1; i <= numbers; i++){
        inputs.push({
        "title": '№' + i,
         "id": i
        })
        }
        setValues(inputs)
      } else if(numbers == '') {
        let inputs = []
        for (let i = 1; i <= regForm.quantityMaterial; i++){
          inputs.push({
          "title": '№' + i,
          "id": i
          })
        }
        setValues(inputs)
      }
    },[numbers])

    const updateHandler = async(id, scan) => {
      await laborantService.updateLabForm(id, {data: scan.data}).then(res=>{
        if (res) toast.done('Дані внесено')
      })
      await laborantService.updateStatusDirection(id, {status: scan.status}).then(res=>{
        if (res)  toast.info('Статус скерування оновлено')
      })
    }

    useEffect(()=>{
      if(scaned.data.cassets.length >= 1 ){
          let id = regForm.id
          updateHandler(id,scaned)
          dispatch(resultsFormating(scaned))
          dispatch(ClearInputs())
      } else {
        toast.error('Скануйте касети!')
      }
    },[scaned])

    const status = regForm.status
    let gistTitle = ''

    if (status === 'scanAfterForm'){
      gistTitle = 'Скануйте касети'
    } else if (status === 'scanBeforePaint'){
      gistTitle = 'Скануйте скельця'
    } else if (status === 'scanAfterPaint'){
      gistTitle = 'Передати Лікарю'
    }

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <label className={classes.form__legend}>Скануйте скельце</label>
        {values !== undefined && values.map((el, index)=>(
          <div key={index} className={classes.form__container}>
            <label className={classes.form__label}>{el.title}</label>
            <input className={classes.form__input} required={true} placeholder='Скануйте QR-code' {...register(`Scan №${el.id}`)}/>
          </div>
          ))
        }
        {regForm.research === 'Гістологія' ? <button className={classes.form__button} type='submit'>{gistTitle}</button> : <button className={classes.form__button} type='submit'>Передати Лікарю</button>}
    </form>
  )
}


export default ScanFinished